module.exports = __webpack_public_path__ + "7fd1d3e61ff4a5d7f4d1177565aa27f1.png";